import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import type { GetEventSettingsDto } from '@/types/dtos/events/response/get-event-settings.dto';
import { useTranslations } from '@/i18n/use-translations';
import { FlowHostMediaDefaultsFields } from './flow-host-media-defaults-fields';

type FlowHostMediaDefaultsModalProps = {
  open: boolean;
  onClose: () => void;
  flow: FlowDto;
  eventSettings?: GetEventSettingsDto | null;
  multiFlow?: boolean;
};

export function FlowHostMediaDefaultsModal({
  open,
  onClose,
  flow,
  eventSettings,
  multiFlow = false,
}: FlowHostMediaDefaultsModalProps) {
  const t = useTranslations();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>{t('media.settings.hosts.permissions')}</DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('media.settings.hosts.permissionsIntro')}
        </Typography>
        <FlowHostMediaDefaultsFields flow={flow} eventSettings={eventSettings} multiFlow={multiFlow} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
